import React, { useContext, useState } from "react";
import {
	SolicitudesPendientesAprobarPage,
	MisSolicitudesPage,
	HistoricoSolicitudesPage,
	CalendarioPage,
} from "./componentes";
import { Card, Tabs } from "antd";
import { SecurityContext } from "context/SecurityContextProvider";
import { ProgramarVacacionesPage } from "./componentes/programar-vacaciones";
import { ProgramarMovimientosPage } from "./componentes/programar-movimientos";

const parametros = window.location.search;
const buscadorParametros = new URLSearchParams(parametros);

const VacacionesPageWeb = () => {
	const sesionTab = buscadorParametros.get("sesionTab");
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const [activeTabKey, setActiveTabKey] = useState(sesionTab ? sesionTab : "misSolicitudes");
	const isTrinyRent = getUsuarioAutenticado().empresaSeleccionada.razonSocial.toUpperCase().includes("TRINY RENTAL SAC")
		? true
		: false;
	const isGlore = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20555936045";
	const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
	const isPSP = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20601257280";

	const mostrarHistorico = (isSDF || isSDFEnergia) ? (getUsuarioAutenticado().empresaSeleccionada?.colaborador?.aprobadoresPrimerNivel
		|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.aprobadoresSegundoNivel
		|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.aprobadoresTercerNivel
		|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.otrosAprobadoresPrimerNivel
		|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.cargoNombre ==="COORDINADORA DE BIENESTAR SOCIAL") : true;

	const tabs = [
		{
			key: "misSolicitudes",
			tab: "Mis Solicitudes",
		},
		// {
		// 	key: "solicitudesPendientesAprobacion",
		// 	tab: "Pendientes de Aprobación",
		// },
		...(!isPSP && mostrarHistorico
			? [
				{ key: "solicitudesPendientesAprobacion", tab: "Pendientes de Aprobación" },
				{ key: "historicoSolicitudes", tab: "Histórico Solicitudes" },
			]
			: [])
	];

	if (!isPSP && (getUsuarioAutenticado().empresaSeleccionada?.colaborador?.jefeInmediato
		|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.otrosAprobadoresVacaciones
		|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.aprobadoresPrimerNivel
		|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.otrosAprobadoresPrimerNivel)) {
		tabs.push({
			key: "calendario",
			tab: "Calendario",
		});
	}

	if (isTrinyRent && (getUsuarioAutenticado().empresaSeleccionada?.colaborador?.jefeInmediato || getUsuarioAutenticado().empresaSeleccionada?.colaborador?.otrosAprobadoresVacaciones)) {
		tabs.push({
			key: "programarVacaciones",
			tab: "Programar Vacaciones",
		});
	}

	if (!isGlore && (getUsuarioAutenticado().empresaSeleccionada?.colaborador?.aprobadoresPrimerNivel
	|| getUsuarioAutenticado().empresaSeleccionada?.colaborador?.otrosAprobadoresPrimerNivel)) {
		tabs.push({
			key: "programarMovimientos",
			tab: "Medidas Disciplinarias",
		});
	}
	const listaTabs = {
		misSolicitudes: <MisSolicitudesPage />,
		solicitudesPendientesAprobacion: <SolicitudesPendientesAprobarPage />,
		historicoSolicitudes: <HistoricoSolicitudesPage />,
		calendario: <CalendarioPage />,
		programarVacaciones: <ProgramarVacacionesPage />,
		programarMovimientos: <ProgramarMovimientosPage />
	};

	const onTabChange = (key) => {
		setActiveTabKey(key);
	};

	return (
		<Card
			tabList={tabs}
			activeTabKey={activeTabKey}
			onTabChange={(key) => {
				onTabChange(key);
			}}
			// tabBarExtraContent={<BotonesExtra tab={activeTabKey} />}
			bodyStyle={{ height: "calc(100vh - 185px)", padding: "0px" }}
		>
			{listaTabs[activeTabKey]}
		</Card>
		// <React.Fragment>
		// 	<div
		// 		style={{
		// 			padding: "10px 20px",
		// 			background: "white",
		// 			minHeight: "calc(100vh - 130px)",
		// 		}}
		// 	>
		// 		<Tabs destroyInactiveTabPane={true} defaultActiveKey={sesionTab ? sesionTab : "calendario"}>
		// 			<Tabs.TabPane tab="Mis Solicitudes Vacacionales" key="mis-solicitudes">
		// 				<div style={{ padding: "10px 10px" }}>
		// 					<MisSolicitudesPage />
		// 				</div>
		// 			</Tabs.TabPane>
		// 			<Tabs.TabPane tab="Pendientes de Aprobación" key="solicitudes-pendientes-aprobacion">
		// 				<SolicitudesPendientesAprobarPage />
		// 			</Tabs.TabPane>
		// 			<Tabs.TabPane tab="Histórico Solicitudes" key="historico-solicitudes">
		// 				<HistoricoSolicitudesPage />
		// 			</Tabs.TabPane>
		// 			{getUsuarioAutenticado().empresaSeleccionada?.colaborador?.jefeInmediato && (
		// 				<Tabs.TabPane tab="Calendario" key="calendario">
		// 					<CalendarioPage />
		// 				</Tabs.TabPane>
		// 			)}
		// 		</Tabs>
		// 	</div>
		// </React.Fragment>
	);
};

export default VacacionesPageWeb;
